import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const NOTE_SKELETON_COUNT: number = 4;

const NotesSkeletonList = () => (
  <div className="offline-sr-notes-scroll">
    {Array.from({ length: NOTE_SKELETON_COUNT }, (_, index: number) => (
      <div key={`note-skeleton-${index}`} className="note-card">
        <div className="note-card-title">
          <Skeleton variant="text" width="40%" />
        </div>
        <div className="note-card-content">
          <div className="note-card-body">
            <Skeleton variant="text" width="95%" />
            <div style={{ marginTop: '0.5rem' }}>
              <Skeleton variant="text" width="80%" />
            </div>
            <div style={{ marginTop: '0.5rem' }}>
              <Skeleton variant="text" width="60%" />
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default NotesSkeletonList;
